"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServiceBaseUrl = exports.getService = exports.removeInstance = exports.setInstance = void 0;
const axios_1 = __importDefault(require("axios"));
const instanceMap = {};
const setInstance = (key, value) => {
    instanceMap[key] = value;
};
exports.setInstance = setInstance;
const removeInstance = (key) => {
    delete instanceMap[key];
};
exports.removeInstance = removeInstance;
const getService = async (key, config, options) => {
    const api = instanceMap[key];
    if (!api) {
        throw new Error("Must set the axios instance");
    }
    const source = axios_1.default.CancelToken.source();
    const promise = api({
        ...config,
        ...options,
        cancelToken: source.token,
    });
    api.interceptors.request.use((config) => {
        if (config.headers["Authorization"]) {
            delete config.headers["Authorization"];
        }
        return config;
    }, (error) => {
        Promise.reject(error);
    });
    promise.cancel = () => {
        source.cancel("Query was cancelled");
    };
    return promise
        .then((response) => [undefined, response])
        .catch((error) => [error, undefined]);
};
exports.getService = getService;
const updateServiceBaseUrl = (key, url) => {
    const api = instanceMap[key];
    if (api) {
        api.defaults.baseURL = url;
    }
    else {
        throw new Error(`No API matches: ${key}`);
    }
};
exports.updateServiceBaseUrl = updateServiceBaseUrl;
//# sourceMappingURL=instance.js.map